import { trimParams } from "./utils";

export const filterSearchParams = (params) => {
	if (!params) {
		return;
	}

	const trimmedParams = trimParams(params);

	return Object.fromEntries(
		Object.entries(trimmedParams).filter(
			([key, val]) => key && val !== undefined && val !== "",
		),
	);
};
